export const blockIconsHouseholdFoundationNew = (
	<span className='material-symbols-outlined'>foundation</span>
);
